export default __webpack_public_path__ + "static/media/production-city.1d37755a.webp";